module.exports = __webpack_public_path__ + "img/icon_repositorio_unico_hover.c59f5e51.png";